module.exports = __webpack_public_path__ + "static/img/09.ea22941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znhy/09.jpg
// module id = /EoO
// module chunks = 1